module.exports = "/lucky-balls/img/combos/7-.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos/7-.png
// module id = 1004
// module chunks = 0